// extracted by mini-css-extract-plugin
export default {"movieCard":"MovieCard_movieCard__boWL6","movieImage":"MovieCard_movieImage__XFFft","movieTitle":"MovieCard_movieTitle__OZLGr","movieLink":"MovieCard_movieLink__TwLCx"};